module.exports = __webpack_public_path__ + "static/media/ml.1f0833ef.svg";